import { BeneficiaryBusinessRole } from '../../legacy/Pages/ShareholdersBusinessRole/types';

const ELIGIBILITY_KEY = 'onboarding.eligibility';

export const getEligibility = (): BeneficiaryBusinessRole | null => {
  const storedEligibility = window.localStorage.getItem(ELIGIBILITY_KEY);

  if (!storedEligibility) {
    return null;
  }

  return JSON.parse(storedEligibility);
};
